/* Puff Land – script chargé par les sections concernées (dépend de theme.js) */
(() => {
  'use strict';
  const PL = window.PL;
  if (!PL || !PL.u || PL.loaded_compare) return;
  PL.loaded_compare = true;
  const { $, $$, debounce, parseHTML, storage, formatMoney, toast, trapFocus, esc, norm, num, fill, fetchProductData, productDataUrl, productBase, starsHTML, buyButton, isDesktop, reduceMotion, initWishlistButtons, applyDiscountCode, getCart, refreshCart } = PL.u;
  const S = PL.strings;
  const R = PL.routes;
  const Cart = PL.cart;
  const Compare = PL.compare;

  /* ---------- Tableau comparatif ---------- */
  const DEFAULT_ROWS = [
    { label: 'Prix', key: 'p', better: 'low' }, { label: 'Note clients', key: 'r', better: 'high' }, { label: 'Marque', key: 'v', better: 'none' },
    { label: 'Saveur', key: 'fl', better: 'none' }, { label: 'Bouffées', key: 'bf', better: 'high' }, { label: 'Batterie', key: 'bat', better: 'high' },
    { label: 'Capacité', key: 'cap', better: 'high' }, { label: 'Nicotine', key: 'nic', better: 'none' }, { label: 'Disponibilité', key: 'av', better: 'none' }
  ];
  /* Marque d'un produit : fournisseur, sinon titre (« Puff JNR FalconX » → JNR), comme snippets/brand-resolve */
  const brandKey = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
  const findBrand = (vendor, title) => {
    const list = PL.brands || [];
    const match = (k) => k && list.find((b) => b.k === k || (b.a || []).includes(k));
    let hit = match(brandKey(vendor));
    if (!hit && title) {
      const t = String(title).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(/[^a-z0-9]+/).filter(Boolean);
      for (let i = 0; i < t.length && !hit; i++) hit = match(t[i]) || match(t[i] + (t[i + 1] || '')) || match(t[i] + (t[i + 1] || '') + (t[i + 2] || ''));
    }
    return hit || null;
  };
  const cellValue = (p, key) => {
    switch (key) {
      case 'p': return { html: `<strong>${esc(formatMoney(p.p))}</strong>${p.c > p.p ? ` <s class="text-muted">${esc(formatMoney(p.c))}</s>` : ''}`, raw: p.p, text: String(p.p) };
      case 'r': return p.r ? { html: `<span class="rating">${starsHTML(p.r)}<span class="rating__value">${Number(p.r).toFixed(1)}</span><span class="rating__count">(${p.rc})</span></span>`, raw: Number(p.r), text: String(p.r) } : { html: '—', raw: NaN, text: '' };
      case 'v': {
        const brand = findBrand(p.v, p.t);
        const name = brand ? brand.n : p.v;
        if (!name) return { html: '—', raw: NaN, text: '' };
        return { html: brand && brand.l ? `<span class="cmp__brand"><img src="${esc(brand.l)}" alt="" width="80" height="40" loading="lazy">${esc(name)}</span>` : esc(name), raw: NaN, text: norm(name) };
      }
      case 'av': return { html: p.av ? `<span class="stock stock--in">${esc(S.inStock)}</span>` : `<span class="stock stock--out">${esc(S.soldOut)}</span>`, raw: NaN, text: String(p.av) };
      default: {
        const v = p[key];
        return v ? { html: esc(v), raw: num(v), text: norm(v) } : { html: '—', raw: NaN, text: '' };
      }
    }
  };
  const renderCompareTable = (products, rows = DEFAULT_ROWS) => {
    const head = products.map((p) => `<th scope="col" class="cmp__col">
      <div class="cmp__prod">
        <button type="button" class="cmp__remove" data-compare-remove="${esc(p.h)}" aria-label="${esc(S.compareRemove)} : ${esc(p.t)}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
        <a href="${esc(p.u)}" class="cmp__img" tabindex="-1" aria-hidden="true">${p.img ? `<img src="${esc(p.img)}" alt="" width="140" height="140" loading="lazy">` : ''}</a>
        <a href="${esc(p.u)}" class="cmp__title">${esc(p.t)}</a>
        ${buyButton(p, 'btn btn--primary btn--small btn--block')}
      </div></th>`).join('');
    const body = rows.map((row) => {
      const cells = products.map((p) => cellValue(p, row.key));
      if (cells.every((c) => c.html === '—')) return '';
      let bestIdx = [];
      const nums = cells.map((c) => c.raw).filter((n) => !isNaN(n));
      if (row.better !== 'none' && nums.length > 1 && new Set(nums).size > 1) {
        const target = row.better === 'low' ? Math.min(...nums) : Math.max(...nums);
        bestIdx = cells.map((c, i) => (c.raw === target ? i : -1)).filter((i) => i > -1);
      }
      const same = new Set(cells.map((c) => c.text)).size === 1;
      return `<tr${same ? ' data-same' : ''}><th scope="row">${esc(row.label)}</th>${cells.map((c, i) => `<td${bestIdx.includes(i) ? ' class="is-best"' : ''}>${c.html}${bestIdx.includes(i) ? ` <span class="cmp__best">${esc(S.compareBest)}</span>` : ''}</td>`).join('')}</tr>`;
    }).join('');
    return `<div class="cmp-wrap"><table class="cmp" style="--n:${products.length}"><thead><tr><th scope="col" class="cmp__corner">${esc(S.compareProduct)}</th>${head}</tr></thead><tbody>${body}</tbody></table></div>`;
  };

  class CompareTable extends HTMLElement {
    connectedCallback() {
      try { this.rows = JSON.parse(this.dataset.rows || '[]'); } catch (e) { this.rows = []; }
      if (!this.rows.length) this.rows = DEFAULT_ROWS;
      this.target = $('[data-compare-target]', this);
      this.cache = {};
      $('[data-compare-diff]', this).addEventListener('change', (e) => this.classList.toggle('is-diff', e.target.checked));
      this.onUpdate = () => this.load();
      document.addEventListener('compare:updated', this.onUpdate);
      this.load();
    }
    disconnectedCallback() { document.removeEventListener('compare:updated', this.onUpdate); }
    async load() {
      const list = Compare.list();
      $('[data-compare-empty]', this).hidden = list.length > 0;
      $('[data-compare-toolbar]', this).hidden = list.length === 0;
      if (!list.length) { this.target.innerHTML = ''; return; }
      const data = await Promise.all(list.map((x) => this.cache[x.h] || (this.cache[x.h] = fetchProductData(productDataUrl(x.h)).catch(() => null))));
      const products = data.filter(Boolean);
      this.target.innerHTML = renderCompareTable(products, this.rows);
      initWishlistButtons(this);
    }
  }
  if (!customElements.get('compare-table')) customElements.define('compare-table', CompareTable);

  /* ---------- Comparateur intelligent (questionnaire + recommandations) ---------- */
  /* Variante qui correspond le mieux aux réponses (saveur, dosage de nicotine), disponible en priorité : présélectionnée sur la fiche */
  const mgOf = (s) => {
    const t = norm(s).replace(',', '.');
    const m = t.match(/(\d+(?:\.\d+)?)\s*(mg|%)/);
    if (m) return m[2] === '%' ? Math.round(parseFloat(m[1]) * 10) : parseFloat(m[1]);
    if (/sans nicotine|nicotine free|0 nicotine/.test(t)) return 0;
    return null;
  };
  /* exact : une seule variante correspond à toutes les réponses (sinon le dosage, par exemple, n'a pas été choisi : pas d'ajout direct) */
  const pickVariant = (p, answers) => {
    if (!Array.isArray(p.vs) || p.vs.length < 2) return null;
    let best = null;
    let bestScore = 0;
    let bestMatch = 0;
    let ties = 0;
    p.vs.forEach(([id, av, title]) => {
      const t = norm(title);
      let sc = 0;
      answers.forEach((a) => {
        if (!a || a.values.includes('*')) return;
        const kws = a.values.flatMap((v) => String(v).split(','));
        if (a.criterion === 'nicotine') {
          const mg = mgOf(title);
          if (mg !== null && kws.map(mgOf).includes(mg)) sc += 2;
        } else if (a.criterion === 'flavor') {
          if (kws.map((k) => norm(k).trim()).filter((k) => k.length > 2).some((k) => t.includes(k))) sc += 2;
        }
      });
      if (sc > bestMatch) { bestMatch = sc; ties = 1; } else if (sc > 0 && sc === bestMatch) ties += 1;
      if (sc > 0 && av) sc += 1;
      if (sc > bestScore) { bestScore = sc; best = { id, av: !!av, title }; }
    });
    if (best) best.exact = ties === 1;
    return best;
  };
  const variantUrl = (x) => (x.variant ? `${x.p.u}${x.p.u.includes('?') ? '&' : '?'}variant=${x.variant.id}` : x.p.u);

  class SmartFinder extends HTMLElement {
    connectedCallback() {
      this.steps = $$('[data-finder-step]', this);
      this.results = $('[data-finder-results]', this);
      this.answers = [];
      this.index = 0;
      if (!this.steps.length) return;
      this.addEventListener('click', (e) => this.onClick(e));
      const prefetch = () => this.loadData();
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); prefetch(); } }, { rootMargin: '300px' });
        io.observe(this);
      }
      this.updateProgress();
      document.addEventListener('compare:updated', () => {
        const table = $('[data-finder-table]', this);
        if (table.hidden || !this.tableItems) return;
        this.tableItems = this.tableItems.filter((p) => Compare.has(p.h));
        if (this.tableItems.length) table.innerHTML = renderCompareTable(this.tableItems); else table.hidden = true;
      });
    }
    loadData() {
      if (!this.dataPromise) {
        this.dataPromise = fetchProductData(this.dataset.source).then((d) => (Array.isArray(d) ? d : [])).catch(() => { this.dataPromise = null; return []; });
      }
      return this.dataPromise;
    }
    onClick(e) {
      const opt = e.target.closest('.finder__option');
      if (opt) { this.choose(opt); return; }
      if (e.target.closest('[data-finder-next]')) { this.go(this.index + 1); return; }
      if (e.target.closest('[data-finder-skip]')) { this.answers[this.index] = null; $$('.finder__option', this.steps[this.index]).forEach((o) => o.setAttribute('aria-pressed', 'false')); this.go(this.index + 1); return; }
      if (e.target.closest('[data-finder-back]')) { this.go(this.index - 1); return; }
      if (e.target.closest('[data-finder-restart]')) { this.restart(); return; }
      if (e.target.closest('[data-finder-compare]')) { this.compareTop(); }
    }
    choose(opt) {
      const step = this.steps[this.index];
      const multiple = step.dataset.multiple === 'true';
      const opts = $$('.finder__option', step);
      const isAny = opt.dataset.value === '*';
      if (multiple && !isAny) {
        opts.forEach((o) => { if (o.dataset.value === '*') o.setAttribute('aria-pressed', 'false'); });
        opt.setAttribute('aria-pressed', opt.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      } else {
        opts.forEach((o) => o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'));
      }
      const chosen = opts.filter((o) => o.getAttribute('aria-pressed') === 'true');
      this.answers[this.index] = chosen.length ? {
        criterion: step.dataset.criterion,
        weight: parseInt(step.dataset.weight, 10) || 1,
        values: chosen.map((o) => o.dataset.value),
        labels: chosen.map((o) => o.dataset.label)
      } : null;
      const next = $('[data-finder-next]', step);
      if (next) next.disabled = chosen.length === 0;
      if (!multiple || isAny) setTimeout(() => this.go(this.index + 1), reduceMotion ? 0 : 220);
    }
    go(i) {
      if (i < 0) return;
      this.steps.forEach((s, k) => { s.hidden = k !== i; s.classList.toggle('is-active', k === i); });
      this.index = i;
      if (i >= this.steps.length) { this.showResults(); }
      else {
        this.results.hidden = true;
        const first = $('.finder__option', this.steps[i]);
        if (first && this.started) first.focus({ preventScroll: true });
      }
      this.started = true;
      this.updateProgress();
    }
    updateProgress() {
      const total = this.steps.length;
      const done = Math.min(this.index, total);
      const pct = Math.round((done / total) * 100);
      const bar = $('[data-finder-bar]', this);
      if (bar) bar.style.width = `${pct}%`;
      const pctEl = $('[data-finder-percent]', this);
      if (pctEl) pctEl.textContent = `${pct} %`;
      const label = $('[data-finder-step-label]', this);
      if (label) label.textContent = fill(S.finderStep, { current: Math.min(this.index + 1, total), total });
    }
    restart() {
      this.answers = [];
      $$('.finder__option', this).forEach((o) => o.setAttribute('aria-pressed', 'false'));
      $$('[data-finder-next]', this).forEach((b) => { b.disabled = true; });
      $('[data-finder-table]', this).hidden = true;
      this.go(0);
    }
    score(p, answers, strictCategory) {
      const fields = {
        category: [p.ty, (p.tg || []).join(' '), p.t],
        flavor: [p.fl, p.fam, p.t, (p.tg || []).join(' ')],
        level: [p.lvl, (p.tg || []).join(' '), p.t, p.ty, p.ex],
        brand: [p.v, (findBrand(p.v, p.t) || {}).n],
        nicotine: [p.nic, (p.tg || []).join(' '), p.t],
        keywords: [p.t, p.ty, p.v, p.fl, p.fam, p.lvl, (p.tg || []).join(' '), p.ex]
      };
      let score = 0; let max = 0; const reasons = []; let excluded = false;
      answers.forEach((a) => {
        if (!a || a.values.includes('*')) return;
        max += a.weight;
        if (a.criterion === 'budget' || a.criterion === 'autonomy') {
          const value = a.criterion === 'budget' ? p.p / 100 : num(p.bf);
          let best = 0;
          a.values.forEach((v) => {
            const [mn, mx] = v.split('-').map(Number);
            if (isNaN(value)) { best = Math.max(best, 0.25); return; }
            if (value >= mn && value <= (isNaN(mx) ? Infinity : mx)) { best = 1; return; }
            const dist = value < mn ? mn - value : value - mx;
            const width = Math.max((mx || mn) - mn, mn * 0.5, 5);
            best = Math.max(best, Math.max(0, 1 - dist / width) * 0.6);
          });
          score += a.weight * best;
          if (best === 1) reasons.push(a.criterion === 'budget' ? fill(S.finderBudget, { price: formatMoney(p.p) }) : fill(S.finderPuffs, { n: p.bf }));
          return;
        }
        const hay = norm((fields[a.criterion] || fields.keywords).join(' '));
        const hitIdx = a.values.findIndex((v) => v.split(',').map((k) => norm(k).trim()).filter((k) => k.length > 1).some((k) => hay.includes(k)));
        if (hitIdx > -1) {
          score += a.weight;
          reasons.push(a.criterion === 'flavor' && p.fl ? `${a.labels[hitIdx]} : ${p.fl}` : a.labels[hitIdx]);
        } else if (a.criterion === 'category' && strictCategory) {
          excluded = true;
        }
      });
      if (p.r >= 4) reasons.push(fill(S.finderRating, { r: Number(p.r).toFixed(1), n: p.rc }));
      if (p.c > p.p) reasons.push(fill(S.finderPromo, { pct: Math.round(((p.c - p.p) * 100) / p.c) }));
      const pct = max ? Math.round((score / max) * 100) : 100;
      const variant = pickVariant(p, answers);
      if (variant) reasons.unshift(fill(S.finderVariant, { variant: variant.title }));
      return { p, pct, score, excluded, variant, reasons: reasons.slice(0, 4) };
    }
    async showResults() {
      this.results.hidden = false;
      const loading = $('[data-finder-loading]', this);
      const cardsEl = $('[data-finder-cards]', this);
      const actions = $('[data-finder-actions]', this);
      cardsEl.innerHTML = ''; actions.hidden = true; $('[data-finder-table]', this).hidden = true;
      loading.hidden = false;
      const data = await this.loadData();
      loading.hidden = true;
      const answers = this.answers.filter(Boolean);
      $('[data-finder-summary]', this).textContent = answers.length ? fill(S.finderSummary, { answers: answers.map((a) => a.labels.join(', ')).join(' · ') }) : '';
      if (!data.length) { cardsEl.innerHTML = `<li class="finder__none">${esc(S.finderEmpty)}</li>`; this.results.focus(); return; }
      const strict = this.dataset.categoryFilter === 'true';
      let scored = data.filter((p) => p.av && p.vis !== '0').map((p) => this.score(p, answers, strict));
      let note = '';
      const kept = scored.filter((x) => !x.excluded);
      if (kept.length) scored = kept; else note = S.finderNone;
      scored.sort((a, b) => b.score - a.score || (b.p.r || 0) - (a.p.r || 0) || (b.p.rc || 0) - (a.p.rc || 0));
      const top = scored.slice(0, parseInt(this.dataset.results, 10) || 3);
      if (top.length && top[0].pct < 50) note = S.finderNone;
      this.top = top.map((x) => x.p);
      cardsEl.innerHTML = (note ? `<li class="finder__none">${esc(note)}</li>` : '') + top.map((x, i) => `
        <li class="finder-card${i === 0 ? ' finder-card--best' : ''}">
          ${i === 0 ? `<span class="finder-card__best">${esc(S.finderBest)}</span>` : ''}
          <a href="${esc(variantUrl(x))}" class="finder-card__media" tabindex="-1" aria-hidden="true">${x.p.img ? `<img src="${esc(x.p.img)}" alt="" width="200" height="200" loading="lazy">` : ''}</a>
          <div class="finder-card__body">
            <span class="finder-card__match" style="--pct:${x.pct}%"><span>${esc(fill(S.finderMatch, { pct: x.pct }))}</span></span>
            <a href="${esc(variantUrl(x))}" class="finder-card__title">${esc(x.p.t)}</a>
            ${x.p.fl ? `<p class="finder-card__flavor">${esc(x.p.fl)}</p>` : ''}
            <ul class="finder-card__reasons">${x.reasons.map((r) => `<li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>${esc(r)}</li>`).join('')}</ul>
            <div class="finder-card__bottom">
              <div class="price${x.p.c > x.p.p ? ' price--sale' : ''}"><span class="price__current">${esc(formatMoney(x.p.p))}</span>${x.p.c > x.p.p ? `<s class="price__compare">${esc(formatMoney(x.p.c))}</s>` : ''}</div>
              <div class="finder-card__btns">
                <button type="button" class="compare-btn" data-compare-toggle data-handle="${esc(x.p.h)}" data-title="${esc(x.p.t)}" data-img="${esc(x.p.img)}" aria-pressed="false" aria-label="${esc(S.compareAdd)}"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3.5v17M7 20.5h10M5 7h14M5 7l-3 7a3.5 3.5 0 0 0 6 0zM19 7l-3 7a3.5 3.5 0 0 0 6 0z"/></svg></button>
                ${buyButton(x.variant && x.variant.av && x.variant.exact ? { ...x.p, u: variantUrl(x), single: true, av: true, vid: x.variant.id } : { ...x.p, u: variantUrl(x) })}
              </div>
            </div>
          </div>
        </li>`).join('');
      Compare.syncButtons(cardsEl);
      actions.hidden = top.length < 2;
      this.results.focus({ preventScroll: true });
      this.results.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
    compareTop() {
      if (!this.top || !this.top.length) return;
      const items = this.top.slice(0, Compare.max());
      this.tableItems = items;
      Compare.set(items.map((p) => ({ h: p.h, t: p.t, img: p.img })));
      const table = $('[data-finder-table]', this);
      table.innerHTML = renderCompareTable(items);
      table.hidden = false;
      table.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    }
  }
  if (!customElements.get('smart-finder')) customElements.define('smart-finder', SmartFinder);
})();
